export default function MySQL_STUDYPLAN() {
  return (
    <div>
      <h2>MySQL_STUDYPLAN</h2>    </div>
  );
}